import {Injectable} from '@angular/core';
import {Certificate} from './models/certificate';
import {CertificateStatus} from './models/certificate-status.enum';

@Injectable({
  providedIn: 'root'
})
export class CertificateService {

  private certificates: Certificate[] = [
    new Certificate({
      identifier: 'C0012020',
      description: 'Demo Cert 001',
      issuer: 'Xebia',
      expiryDate: new Date(),
      status: CertificateStatus.APPROVED,
      thumbnail: 'cert1.png',
      filename: 'cert1.pdf',
      owner: 'professional@otentica.nl'
    }),
    // new Certificate({
    //   identifier: 'C0212020',
    //   description: 'Demo Cert 042',
    //   issuer: 'Xebia',
    //   expiryDate: new Date(),
    //   status: CertificateStatus.APPROVED,
    //   thumbnail: 'cert2.png',
    //   owner: 'professional@otentica.nl'
    // }),
    // new Certificate({
    //   identifier: 'C0222020',
    //   description: 'Demo Cert 061',
    //   issuer: 'Oxford',
    //   expiryDate: new Date(),
    //   status: CertificateStatus.PENDING_APPROVAL,
    //   owner: 'professional@otentica.nl'
    // }),
    // new Certificate({
    //   identifier: 'C0262020',
    //   description: 'Demo Cert 062',
    //   issuer: 'Oxford',
    //   expiryDate: new Date(),
    //   status: CertificateStatus.REJECTED,
    //   owner: 'professional@otentica.nl'
    // })
  ];

  constructor() { }

  getCertificates(): Certificate[] {
    return this.certificates;
  }

  addCertificate(certificate: Certificate): void {
    this.certificates.push(certificate);
  }

  removeCertificateById(certificateId: string): void {

  }

  getById(id: string): Certificate {
    return this.certificates.filter(cert => cert.identifier === id)[0];
  }
}

